import React from 'react'

import NewFormula from './NewFormula'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'


const NewFormulaPage = () => (
  <section>
    <header>
      <PageTitle>New formula</PageTitle>
    </header>
    <NewFormula showSuccessDialog={true} />
    <br/>
    <BackButton/>
  </section>
)

export default NewFormulaPage



// WEBPACK FOOTER //
// ./src/components/Formulas/NewFormulaPage.jsx